// extracted by mini-css-extract-plugin
export var createdDate = "_o6-1";
export var divider = "_o6-2";
export var headerDivider = "_o6-3";
export var messagesCard = "_o6-0";
export var messagesContainer = "_o6-7";
export var messagesContainerWrapper = "_o6-4";
export var pointerCapturingButtonBoxes = "_o6-a";
export var showLeftPanelButton = "_o6-9";
export var showMoreButton = "_o6-c";
export var showMoreButtonContainer = "_o6-b";
export var summaryTitle = "_o6-6";
export var systemMessageCardWrapper = "_o6-d";
export var topButtons = "_o6-8";
export var withPadding = "_o6-5";